import React from 'react';
import moment from 'moment';
import { TAnnex6V2Record } from '../../../../../../../redux/app/annex6-v2/@types';
import { TAnnex6V2GroupI1 } from '../../../../../../../redux/app/annex6-v2/groups/group-i';
import Annex6V2TableRows from '../../_elements_v2/Annex6V2TableRows';

type OwnProps = {
    annex6V2Record: TAnnex6V2Record;
    isStrikedOff?: boolean;
    theme?: 'light' | 'dark';
};
type Annex6V2GroupI1PreviewProps = OwnProps;

function Annex6V2GroupI1Preview(props: Annex6V2GroupI1PreviewProps) {
    const record = props.annex6V2Record as TAnnex6V2GroupI1;
    const operationDate = moment(record.selectedDate, 'YYYY-MM-DD').format(
        'DD-MMM-YYYY'
    );
    const { itemI1P1, itemI1P2 } = record;
    const {
        sampleDetails: { bunkering, sample },
    } = itemI1P2;

    function renderMain() {
        const tableRows = [
            [operationDate, 'I', '1.1', renderItemP1()],
            [null, null, '1.2', renderItemP2()],
            [null, null, '2.1', renderItemP3()],
            [null, null, '2.2', renderItemP4()],
            [null, null, '2.3', renderItemP5()],
        ];

        if (record.remarks) {
            tableRows.push([null, null, 'NOTE', record.remarks]);
        }

        return (
            <Annex6V2TableRows
                record={record}
                tableRows={tableRows}
                theme={props.theme}
            />
        );
    }

    function renderItemP1() {
        return (
            <h4 className="font-medium uppercase">
                Reason: {itemI1P1.custodyTransferDetails.reason}
            </h4>
        );
    }

    function renderItemP2() {
        const {
            receiverName,
            receiverDesignation,
            receiverAddress,
            receiverContact,
        } = itemI1P1.custodyTransferDetails;
        return (
            <h4 className="font-medium uppercase">
                <div>
                    <p>
                        Name: {receiverName}, Designation: {receiverDesignation}
                    </p>
                    <p>Address: {receiverAddress}</p>
                    <p>Contact Details: {receiverContact}</p>
                </div>
            </h4>
        );
    }

    function renderItemP3() {
        return (
            <h4 className="font-medium uppercase">
                Bunkered on {bunkering.date} (SMT) at {bunkering.time} (SMT) in{' '}
                {bunkering.port}
            </h4>
        );
    }

    function renderItemP4() {
        return (
            <h4 className="font-medium uppercase">
                Sample Date: {sample.date} (SMT), BDN number: {sample.bdn}, Fuel
                Oil Grade: {sample.fuelOilGrade}
            </h4>
        );
    }

    function renderItemP5() {
        return (
            <h4 className="font-medium uppercase">
                Sample Seal Number: {sample.sampleSealNo}
            </h4>
        );
    }

    return renderMain();
}

export default Annex6V2GroupI1Preview;
